/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock, RankMock, RecordMock, StageMock} from './mock'

export const getHomepage = createAsyncThunk(
  'CricketWars/getHomepage',
  async (_, store: any) => {
    // todo mock
    // return {data: HomepageMock}
    const resp = await http.post(
      '/live/activity/cricket_2025_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getRank = createAsyncThunk(
  'CricketWars/getRank',
  async (p: any, store: any) => {
    // todo mock
    // return {data: RankMock}
    const resp = await http.post(
      '/live/activity/cricket_2025_rank_info',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getStageTaskInfo = createAsyncThunk(
  'CricketWars/getStageTaskInfo',
  async (p: any, store: any) => {
    // todo mock
    // return {data: StageMock}
    const resp = await http.post(
      '/live/commonactivity/get_stage_task_info',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getStageDoneReward = createAsyncThunk(
  'CricketWars/getStageDoneReward',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_stage_done_reward',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)
const initialState = {
  homepage: {
    date_ex: 0,
    job_sys_id: 0,
    is_first: false,
    group_id: 1,
    date_list: [],
    special_gift_list: [],
    rank_contribute_info: [],
  },
  rank: {
    group_info: [],
    user_info: {
      group_id: 1,
    },
    top1_info: {
      group_id: 1,
      name: '',
      avatar: '',
      rank_score: 0,
      expect_coins: 0,
      banner: '',
      is_enter: false,
      room_id: 0,
      mid: 0,
    },
    rank_list: [],
    buff_status: 0,
    buff_ex: 0,
    buff_ef: 0,
    buff_score: 0,
    bonus_pool_coins: 0,
    group_score: 0,
    buff_tag_score: 0,
  },
  stageTask: {
    rewardList: [],
    stages: [],
    stage_score: 0,
  },
}

export const CricketWarsSlice = createSlice({
  name: 'CricketWars',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const {data} = action.payload
      state.homepage = data
    })
    builder.addCase(getRank.fulfilled, (state, action) => {
      const {data} = action.payload
      state.rank = data
    })
    builder.addCase(getStageTaskInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      const rewardList = []
      data?.stages?.forEach((item) => {
        rewardList.push(...item?.reward_infos)
      })
      state.stageTask = {
        ...data,
        rewardList,
      }
    })
  },
})

export default CricketWarsSlice.reducer
